<script lang="ts">
import './Avatar.css'

import { defineComponent, PropType } from 'vue-demi'
import { User } from '@/shared/interfaces/User'
import { ContactInfo } from '@/shared/interfaces/ContactInfo'
import { GroupInfo } from '@/shared/interfaces/GroupInfo'
import { chatsGetName } from '@/store/modules/Chats/Methods/chatsGetName'
import { chatsGetAvatar } from '@/store/modules/Chats/Methods/chatsGetAvatar'
import IconSelf from '@/shared/icons/IconSelf.vue'

export default defineComponent({
  components: {IconSelf},
  props: {
    width: {type: Number, required: true},
    height: {type: Number, required: true},

    user: {type: Object as PropType<User | null>, required: true},
    contact: { type: Object as PropType<ContactInfo>, required: false, default: null },
    groupInfo: {type: Object as PropType<GroupInfo>, default: null},
    isSelf: { type: Boolean, default: false },
  },
  computed: {
    chatLabel(): string {
      const chatName = chatsGetName({
        user: this.user,
        contact: this.contact,
        group_info: this.groupInfo,
      })

      return chatName?.length ? chatName[0] : 'A'
    },
    chatAvatar() {
      return chatsGetAvatar({
        user: this.user as User,
        contact: this.contact as ContactInfo,
        group_info: this.groupInfo,
      })
    },
  },
})
</script>

<template>
  <div
    v-if="!isSelf"
    class="cAvatar"
    :style="{
      width: `${width}px`,
      height: `${height}px`,
      'background-color': chatAvatar ? 'transparent' : '',
      'background-image': chatAvatar ? 'url(' + chatAvatar + ')' : '',
    }"
  >
    <span v-if="!chatAvatar">
      {{ chatLabel }}
    </span>

    <div
      v-if="user?.is_online && !groupInfo"
      class="cAvatar__online"
    />
  </div>
  <div
    v-else
    class="cAvatar__self"
  >
    <IconSelf
      :width="24"
      :height="24"
    />
  </div>
</template>
